import axios from 'axios'

export default {
    createPrivateChannel() {
        return axios.post('/games/multiplayer/private-channel')
    },

    findGame(code) {
        return axios.get('/games/multiplayer/private-channel/find', {
            params: {
                code: code
            }
        })
    },

    generateNick() {
        return axios.post('/games/scholar/generate-nick')
    },

    askForHelp(quizId) {
        return axios.post('/web-api/ask-for-help', {
            quiz_id: quizId
        })
    }
}
